import React from 'react';
import Karuselli from './Karuselli';

function KaivuutyotSv() {
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <h1>Grävarbeten</h1>
        <p></p>
          <h4>- Grundarbeten för byggnadsstommar</h4>
          <h4>- Dränering</h4>
          <h4>- Grävning av vatten- och avloppsledningar</h4>
          <h4>- Grävning av kabeldiken</h4>
          <h4>- Markplanering av gårdar</h4>
          <h4>- Borttagning av stubbar / Plantering</h4>
      </div>
      <div className="carousel-container">
        <Karuselli folder="kaivuutyot" imageCount={14} />
      </div>
    </div>
  );
}

export default KaivuutyotSv;
